module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/248-russia-a0844ab35745bae26824f327106412ad.svg";